(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var MON = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, v); } catch (e) { return null; } }

  /* 1. Ad-matched headline from UTM tags */
  var params = new URLSearchParams(window.location.search);
  var utm = ['utm_content', 'utm_campaign', 'utm_term', 'utm_source'].map(function (k) { return params.get(k) || ''; }).join(' ').toLowerCase();
  if (utm.trim()) ss('pp_utm', utm); else utm = ss('pp_utm') || '';
  var hookEl = $('#pp-hook'), rules = [];
  try { rules = JSON.parse(($('#pp-hooks') || {}).textContent || '[]'); } catch (e) { rules = []; }
  if (hookEl && utm) {
    for (var i = 0; i < rules.length; i++) {
      var words = (rules[i].match || '').split(',').map(function (w) { return w.trim(); }).filter(Boolean);
      var hit = words.some(function (w) { return utm.indexOf(w) !== -1; });
      if (hit) {
        if (rules[i].text) { hookEl.textContent = rules[i].text; hookEl.hidden = false; }
        var sl = +rules[i].slide;
        if (sl > 0) { var th = $('[data-thumb="' + (sl - 1) + '"]'); if (th) th.click(); }
        break;
      }
    }
  }

  /* Arrives-by estimate */
  var eta = $('#pp-eta');
  if (eta) {
    var cutoff = +eta.dataset.cutoff || 14, proc = +eta.dataset.proc || 0, mn = +eta.dataset.min || 3, mx = +eta.dataset.max || 7, wk = eta.dataset.weekends === 'true';
    var isBiz = function (d) { var g = d.getDay(); return g !== 0 && g !== 6; };
    var addBiz = function (d, n, allowWeekend) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (allowWeekend || isBiz(x)) n--; } return x; };
    var fmt = function (d) { return DAYS[d.getDay()] + ', ' + MON[d.getMonth()] + ' ' + d.getDate(); };
    var short = function (d) { return MON[d.getMonth()] + ' ' + d.getDate(); };
    var update = function () {
      var now = new Date(), start = new Date(now);
      var cut = new Date(now); cut.setHours(cutoff, 0, 0, 0);
      if (!isBiz(now) || now >= cut) { start = addBiz(now, 1, false); cut = new Date(start); cut.setHours(cutoff, 0, 0, 0); }
      var ship = proc > 0 ? addBiz(start, proc, false) : start;
      var d1 = addBiz(ship, mn, wk), d2 = addBiz(ship, mx, wk);
      var left = Math.max(0, cut - now), h = Math.floor(left / 3600000), m = Math.floor(left % 3600000 / 60000);
      $('[data-eta-left]', eta).textContent = h > 23 ? fmt(cut) + ' ' + cutoff + ':00' : (h + 'h ' + m + 'm');
      $('[data-eta-by]', eta).textContent = short(d1) + ' – ' + short(d2);
      $('[data-eta-d0]', eta).textContent = short(now);
      $('[data-eta-d1]', eta).textContent = short(ship);
      $('[data-eta-d2]', eta).textContent = short(d1) + ' – ' + short(d2);
    };
    update(); setInterval(update, 30000);
  }

  /* Email popup: exit intent or 50% scroll, once per session */
  var pop = $('#ppop');
  if (pop) {
    var open = function () { if (!pop.hidden || ss('pp_pop')) return; pop.hidden = false; ss('pp_pop', '1'); var em = $('#ppop-email'); if (em) setTimeout(function () { em.focus(); }, 50); };
    var close = function () { pop.hidden = true; };
    if (window.__ppopSuccess || /customer_posted=true/.test(location.search) || /contact_posted=true/.test(location.search)) { pop.hidden = false; }
    var trig = pop.dataset.trigger || 'both';
    if (trig !== 'scroll') {
      document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 0) open(); });
    }
    if (trig !== 'exit') {
      var onS = function () { var h = document.documentElement.scrollHeight - window.innerHeight; if (h > 0 && window.scrollY / h >= 0.5) { open(); window.removeEventListener('scroll', onS); } };
      window.addEventListener('scroll', onS, { passive: true });
    }
    $('#ppop-x').addEventListener('click', close);
    pop.addEventListener('click', function (e) { if (e.target === pop) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* Sold bar: count up and grow from 0 when scrolled into view */
  $$('[data-sf-bar]:not([data-sf-ready])').forEach(function (bar) {
    bar.setAttribute('data-sf-ready', '');
    var num = $('.sf-bar__number', bar), fill = $('.sf-bar__fill', bar), target = parseInt(bar.dataset.soldPercent, 10);
    if (!num || isNaN(target) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    num.textContent = '0'; if (fill) fill.style.width = '0%';
    var started = false, duration = 4800;
    var run = function () {
      if (started) return; started = true;
      var start = null;
      var step = function (t) {
        if (start === null) start = t;
        var p = Math.min((t - start) / duration, 1), eased = 1 - Math.pow(1 - p, 2);
        num.textContent = Math.floor(target * eased);
        if (fill) fill.style.width = (target * eased) + '%';
        if (p < 1) requestAnimationFrame(step); else { num.textContent = target; if (fill) fill.style.width = target + '%'; }
      };
      requestAnimationFrame(step);
      setTimeout(function () { num.textContent = target; if (fill) fill.style.width = target + '%'; }, duration + 300);
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (e) { if (e[0].isIntersecting) { io.disconnect(); run(); } }, { threshold: 0.3 });
      io.observe(bar);
    } else { run(); }
  });

  /* Arrives-by line: today + N business days (skips Sat/Sun) */
  $$('[data-sd-line]:not([data-sd-ready])').forEach(function (line) {
    line.setAttribute('data-sd-ready', '');
    var days = parseInt(line.dataset.days, 10) || 10, d = new Date();
    while (days > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) days--; }
    $('.sd-line__date', line).textContent = d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  });
})();
